'use client'

import React from 'react'
import { Section } from '@/components/Section'
import { Heading } from '@/components/ui/heading'
import { EyebrowItem } from '@/components/EyebrowItem'
import { ProblemBlock } from '../../../payload-types'

export function ProblemClient({ heading, problems }: ProblemBlock) {
  return (
    <Section bgClassName="bg-rock-1">
      <div className="flex flex-col 2xl:flex-row justify-between gap-[80px]">
        <div className="2xl:max-w-[300px]">
          <Heading size="h2">{heading}</Heading>
        </div>
        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-2 gap-x-8 gap-y-16">
          {problems?.map((problem) => (
            <EyebrowItem
              color="punch"
              key={problem.title}
              label={problem.title}
              description={problem.description}
            />
          ))}
        </div>
      </div>
    </Section>
  )
}
